import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => {
      setPost(r.data);
      document.title = `${r.data.title} — MAISON FAUBOURG`;
    });
  }, [slug]);

  if (!post) return <div className="container-max pt-40 pb-20 font-display text-3xl">Chargement…</div>;

  return (
    <article data-testid="blog-post" className="pt-32 pb-24 bg-bone">
      <header className="container-max max-w-4xl">
        <Link to="/journal" className="overline link-arc inline-flex items-center gap-2 mb-10">
          <ArrowLeft className="w-3 h-3" /> Journal
        </Link>
        <p className="overline">{post.category} · {post.read_time}</p>
        <h1 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tighter mt-4">
          {post.title}
        </h1>
        <p className="mt-6 text-ink/60">{new Date(post.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</p>
      </header>

      <div className="container-max mt-12">
        <img src={post.cover} alt={post.title} className="w-full aspect-[16/9] object-cover" />
      </div>

      <div className="container-max max-w-3xl mt-16 prose-content">
        <p className="text-xl md:text-2xl font-display italic text-ink/80 leading-relaxed">
          {post.excerpt}
        </p>
        <div className="mt-10 font-sans text-lg leading-relaxed text-ink/85 whitespace-pre-line">
          {post.content}
        </div>

        <div className="mt-16 p-8 md:p-12 bg-ivory">
          <p className="overline">— Vous voulez aller plus loin ?</p>
          <p className="font-display text-3xl md:text-4xl leading-tight mt-3">Recevez un devis personnalisé sous 48h, offert et sans engagement.</p>
          <a href="/#devis" className="btn-sharp mt-6">Demander un devis</a>
        </div>
      </div>
    </article>
  );
}
